import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';
import game from './modules/game';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        entry,
        game
    },

    state: {
        isVersion2: window._rootData.r === 'mail-base'
    },

    getters: {
        isVersion2: state => state.isVersion2
    },

    mutations: {
        changeMailBase: ( state, payload ) =>
        {
            state.isVersion2 = payload;
        }
    },

    actions: {
        checkMailBase( context )
        {
            if( window._rootData.r === 'mail-base' )
            {
                context.commit( 'changeMailBase', true );
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/app/store/index.js